import React, { useEffect, useState, useMemo } from "react";
import { Flex } from "@chakra-ui/react";
import { FiCheck } from "react-icons/fi";
import NavItem from "../NavItem/NavItem";
import { BsActivity } from "react-icons/bs";
import { BsPencilSquare } from "react-icons/bs";
import { BsFillPeopleFill } from "react-icons/bs";
import { BsPersonWorkspace } from "react-icons/bs";
import { BsHouse } from "react-icons/bs";
import { IoIosSettings } from "react-icons/io";
import { BsFillTagsFill } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../../app/auth/core/AuthContext";
import { IoRocket } from "react-icons/io5";
import { BiTransfer } from "react-icons/bi";
import { ARCHIVE_MODE_ENABLED } from "../../../../app/archive/archiveConfig";

export default function SidebarPage() {
  const [navSize] = useState("large");
  const { userData } = useAuth();
  const [activeNavItem, setActiveNavItem] = useState("");
  const location = useLocation();

  const subItemsCustomer = useMemo(() => {
    const items = [
      { to: "/marketingChase", title: "Seyyar" },
      { to: "/talepler", title: "Talepler" },
      { to: "/customer-list", title: "Müşteriler" },
    ];

    if (userData?.type === "1") {
      items.push(
        { to: "/offers", title: "Teklifler" },
        { to: "/orders", title: "Siparişler" }
      );
    }
    return items;
  }, [userData?.type]);

  const subItemsOperation = useMemo(
    () => [
      { to: "/support", title: "Destek" },
      { to: "/tasks", title: "Görev" },
      { to: "/jobs", title: "İşlerim" },
      { to: "/karekod", title: "Karekod" },       // 🔹 yeni
    ],
    []
  );

  const subItemsProduction = useMemo(() => {
    const items = [
      { to: "/tally", title: "Çetele" },
      { to: "/guarantee", title: "Garanti" },
    ];

    if (userData?.type === "1") {
      items.push(
        { to: "/products", title: "Ürünler" },
        { to: "/manufacturing", title: "Üretim" },
        { to: "/services", title: "Hizmetler" }
      );
    }
    return items;
  }, [userData?.type]);

  const subItemsEmployees = useMemo(() => {
    const items = [
      { to: "/permissions", title: "İzinler" },
      { to: "/my-files", title: "Evraklar" },
      { to: "/costs", title: "Masraflar" },
      { to: "/announcement", title: "Duyurular" },
    ];

    if (userData?.type === "1") {
      items.push(
        { to: "/employees-list", title: "Personel" },
        { to: "/supplier-add", title: "Tedarikçi" },
        { to: "/departments", title: "Departmanlar" }
      );
    }
    return items;
  }, [userData?.type]);

  const subItemsMarketing = useMemo(
    () => [
      { to: "/sms", title: "Sms Gönder" },
      { to: "/email", title: "Email Gönder" },
    ],
    []
  );

  const subItemsPanel = useMemo(
    () => [
      { to: "/customer/detail", icon: FiCheck, title: "Müşteri Paneli" },
      { to: "#", icon: FiCheck, title: "Faaliyet Raporları" },
      { to: "#", icon: FiCheck, title: "Ödeme İşlemleri" },
    ],
    []
  );

  const subItemsSettings = useMemo(
    () => [
      { to: "/settings", icon: FiCheck, title: "Ayarlar" },
      { to: "/settings/data-transfer", icon: BiTransfer, title: "Veri Aktarımı" }, // 🔹 path düzeltildi
    ],
    []
  );

  const archiveSalesItems = useMemo(
    () => [
      { to: "/customer-list", title: "Müşteri Rehberi" },
      { to: "/marketingChase", title: "Teklif Takibi" },
    ],
    []
  );

  const archiveOperationItems = useMemo(
    () => [
      { to: "/support", title: "Destek" },
      { to: "/tasks", title: "Görevler" },
      { to: "/jobs", title: "İşler / Jobs" },
    ],
    []
  );

  const archiveRecordsItems = useMemo(
    () => [{ to: "/tally", title: "Hosting & Domain" }],
    []
  );

  const archivePanelItems = useMemo(
    () => [
      { to: "/panel/customers/add", title: "Panel Musterileri" },
      { to: "/customer/information/edit", title: "Musteri Bilgileri" },
    ],
    []
  );

  useEffect(() => {
    if (checkToValue(subItemsCustomer, location.pathname)) {
      handleNavItemClick("Satış");
    } else if (ARCHIVE_MODE_ENABLED && checkToValue(archivePanelItems, location.pathname)) {
      handleNavItemClick("Panel");
    } else if (checkToValue(subItemsOperation, location.pathname)) {
      handleNavItemClick("Operasyon");
    } else if (checkToValue(subItemsEmployees, location.pathname)) {
      handleNavItemClick("İdari İşler");
    } else if (checkToValue(subItemsProduction, location.pathname)) {
      handleNavItemClick("Planlama");
    } else if (checkToValue(subItemsPanel, location.pathname)) {
      handleNavItemClick("Panel");
    } else if (checkToValue(subItemsSettings, location.pathname)) {
      handleNavItemClick("Ayarlar");
    } else if (checkToValue(subItemsMarketing, location.pathname)) {
      handleNavItemClick("Pazarlama");
    } else {
      handleNavItemClick("Ana Sayfa");
    }
  }, [
    location.pathname,
    subItemsCustomer,
    subItemsEmployees,
    subItemsOperation,
    subItemsPanel,
    subItemsProduction,
    subItemsMarketing,
    subItemsSettings,
    archivePanelItems,
  ]);

  const checkToValue = (items, targetTo) => {
    return items.some((item) => item.to === targetTo);
  };

  const handleNavItemClick = (title) => {
    setActiveNavItem(title);
  };

  return (
    <Flex
      data-archive-navigation="true"
      pos="sticky"
      backgroundColor="#f5f5f5"
      h="100vh"
      mt="5"
      boxShadow="0 4px 12px 0 rgba(0, 0, 0, 0.05)"
      w={navSize === "small" ? "120px" : "200px"}
      flexDir="column"
      justifyContent="space-between"
      overflowY="auto"
      maxHeight="100%"
    >
      <Flex
        p="5%"
        flexDir="column"
        w="100%"
        alignItems={navSize === "small" ? "center" : "flex-start"}
        as="nav"
      >
        <button onClick={() => handleNavItemClick("Ana Sayfa")}>
          <NavItem
            navSize={navSize}
            icon={BsHouse}
            title="Ana Sayfa"
            to={ARCHIVE_MODE_ENABLED ? "/customer-list" : "/dashboard"}
            active={activeNavItem === "Ana Sayfa"}
          />
        </button>

        <button onClick={() => handleNavItemClick("Operasyon")}>
          <NavItem
            navSize={navSize}
            icon={BsActivity}
            title="Operasyon"
            subItems={ARCHIVE_MODE_ENABLED ? archiveOperationItems : subItemsOperation}
            active={activeNavItem === "Operasyon"}
          />
        </button>

        <button onClick={() => handleNavItemClick("Satış")}>
          <NavItem
            navSize={navSize}
            icon={BsFillTagsFill}
            title="Satış"
            subItems={ARCHIVE_MODE_ENABLED ? archiveSalesItems : subItemsCustomer}
            active={activeNavItem === "Satış"}
          />
        </button>

        {ARCHIVE_MODE_ENABLED ? (
          <>
            <button onClick={() => handleNavItemClick("Arşiv Kayıtları")}>
              <NavItem
                navSize={navSize}
                icon={BsFillPeopleFill}
                title="Arşiv Kayıtları"
                subItems={archiveRecordsItems}
                active={activeNavItem === "Arşiv Kayıtları"}
              />
            </button>

            <button onClick={() => handleNavItemClick("Panel")}>
              <NavItem
                navSize={navSize}
                icon={BsPersonWorkspace}
                title="Musteri Paneli"
                subItems={archivePanelItems}
                active={activeNavItem === "Panel"}
              />
            </button>
          </>
        ) : (
          <>
            <button onClick={() => handleNavItemClick("Planlama")}>
              <NavItem
                navSize={navSize}
                icon={BsPencilSquare}
                title="Planlama"
                subItems={subItemsProduction}
                active={activeNavItem === "Planlama"}
              />
            </button>

            <button onClick={() => handleNavItemClick("Pazarlama")}>
              <NavItem
                navSize={navSize}
                icon={IoRocket}
                title="Pazarlama"
                subItems={subItemsMarketing}
                active={activeNavItem === "Pazarlama"}
              />
            </button>

            <button onClick={() => handleNavItemClick("İdari İşler")}>
              <NavItem
                navSize={navSize}
                icon={BsFillPeopleFill}
                title="İdari İşler"
                subItems={subItemsEmployees}
                active={activeNavItem === "İdari İşler"}
              />
            </button>

            <button onClick={() => handleNavItemClick("Ayarlar")}>
              <NavItem
                navSize={navSize}
                icon={IoIosSettings}
                title="Ayarlar"
                subItems={subItemsSettings}
                active={activeNavItem === "Ayarlar"}
              />
            </button>

            <button onClick={() => handleNavItemClick("Panel")}>
              <NavItem
                navSize={navSize}
                icon={BsPersonWorkspace}
                title="Panel"
                to="/panel/customers/add"
                active={activeNavItem === "Panel"}
              />
            </button>
          </>
        )}
      </Flex>
    </Flex>
  );
}
